import type { CSSProperties } from 'react';

export interface TooltipRow {
  label: string;
  value: string;
  color?: string;
}

interface Props {
  title: string;
  rows: TooltipRow[];
  total?: { label: string; value: string };
  style: CSSProperties;
}

/** Values lead, labels follow — the reader already knows the series. */
export function ChartTooltip({ title, rows, total, style }: Props) {
  return (
    <div className="tooltip" style={style} role="tooltip">
      <div className="tooltip-title">{title}</div>
      {rows.map((row) => (
        <div className="tooltip-row" key={row.label}>
          <span className="name">
            {row.color ? <span className="key" style={{ background: row.color }} aria-hidden="true" /> : null}
            {row.label}
          </span>
          <span className="value">{row.value}</span>
        </div>
      ))}
      {total ? (
        <div className="tooltip-row tooltip-total">
          <span className="name">{total.label}</span>
          <span className="value">{total.value}</span>
        </div>
      ) : null}
    </div>
  );
}
